import React from "react";
import styled from "@mui/styled-engine-sc";
import Box from "@mui/material/Box";

const ComponentWrapper = React.forwardRef((props: any, ref: any) => {
  return <Box {...props} ref={ref} />;
});

export const StyledBox = styled(ComponentWrapper)`
  ${({ theme }) => `
    &.product-card-pack  {
      position: absolute;
      bottom: 1px;
      width: calc(100% - 2px);
      left: 1px;
      right: 1px;
    }

    &.basic-border {
      border-radius: ${theme.shape.borderRadius}px;
      border: 2px solid ${theme.palette.grey[400]};
    }
    &.accordion-show-expanded {
      display: none;
    }
    &.accordion-show-summary {
      display: block;
    }
    .Mui-expanded > &{
      .accordion-show-expanded {
        display: block;
      }
      .accordion-show-summary {
        display: none;
      }
    }
    &.border-gray-300 {
      border: 1px solid ${theme.palette.gray.neutralGray300};
      border-radius: 8px;
      padding: 0 ${theme.spacing(3)} ;
      height: 34px;
      display: inline-flex;
      align-items: center;

      &:last-child {
        margin-right: 0;
      }

      &.max-height-20 {
        svg {
          max-height: 20px;
        }
      }

      &.no-margin-bottom {
        margin-bottom: 0;
      }
      svg {
        max-height: 10px;
        width: auto;

        path {
          fill: ${theme.palette.gray.neutralGray700};
        }
      }
    }

    &.horizontal-scroll {
      overflow-x: auto;
      max-width: calc(${window.innerWidth}px -${theme.spacing(3)});
    }

    .assured-price{
      .product-price{
      font-size:12px;
      }
    }

    &.pdp-main-img-container {
      min-height: 400px;

      // mobile S
      @media (min-width: 250px) and (max-width: 350px) {
        min-height: 266px;
      }

      // mobile M
      @media (min-width: 351px) and (max-width: 424px) {
        min-height: 322px;
      }

      // mobile L
      @media (min-width: 425px) and (max-width: 500px) {
        min-height: 372px;
      }

      // tablet
      @media (min-width: 650px) and (max-width: 850px) {
        min-height: 714px;
      }

      // desktop S
      @media (min-width: 900px) and (max-width: 1100px) {
        min-height: 328px;
      }

      // desktop M
      @media (min-width: 1400px) and (max-width: 1500px) {
        min-height: 508px;
      }

      // desktop L
      @media (min-width: 1900px) {
        min-height: 575px;
      }
    }

    &.pdp-img-slider-container {
      // tablet
      @media (min-width: 650px) and (max-width: 850px) {
        min-height: 161px;
      }

      // desktop S
      @media (min-width: 900px) and (max-width: 1100px) {
        min-height: 64px;
      }

      // desktop M
      @media (min-width: 1400px) and (max-width: 1500px) {
        min-height: 110px;
      }

      // desktop L
      @media (min-width: 1900px) {
        min-height: 126px;
      }
    }

    // PLP products container
    &.product-list {
      display: grid;
      grid-template-columns: 320px;
      justify-items: center;
      justify-content: center;
      gap: 20px;

      & .plp-item {
        height: 490px;
        width: 320px;
      }

      @media (min-width: 600px) {
        grid-template-columns: repeat(2, 320px);
      }

      @media (min-width: 960px) {
        grid-template-columns: repeat(2, 320px);
      }

      @media (min-width: 1200px) {
        grid-template-columns: repeat(3, 275px);
        & .plp-item {
          width: 275px;
        }
        & .generic-push {
          & img {
            object-fit: cover !important;
          }
        }
      }

      @media (min-width: 1400px) {
        grid-template-columns: repeat(3, 320px);
        & .plp-item {
          width: 320px;
        }
      }
    }
  `}
`;
